import gql from 'graphql-tag';

const CHANGE_PASSWORD = gql`
mutation PasswordChange($password: String!, $newPassword: String!) {
    passwordChange(password: $password, newPassword: $newPassword)
}
`;

export default CHANGE_PASSWORD;